import budgetModals from '@/views/project-budgets/modals';
import userRatesModals from '@/views/user-rates/modals';

export default {
  'confirm-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/ConfirmModal'
    ),
  'trial-invite-users-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/TrialInviteUsersModal'
    ),
  'copy-invite-links-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/CopyInviteLinksModal'
    ),
  'user-change-company-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/UserChangeCompanyModal'
    ),
  'per-user-pricing-quick-set-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/PerUserPricingQuickSet'
    ),
  'people-picker-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/PeoplePickerModal'
    ),
  'hubspot-add-link': () => import('@sections/Modals/HubspotAddLinkModal'),
  'allocation-modal': () => import('@sections/Modals/AllocationModal'),
  'review-users-modal': () => import('@sections/Modals/ReviewUsers'),
  'review-users-preview-modal': () =>
    import('@sections/Modals/ReviewUsersPreview'),
  'discount-modal': () => import('@sections/Modals/DiscountModal'),
  'explain-roles-modal': () => import('@sections/Modals/ExplainRoles'),
  'unavailable-time-modal': () =>
    import('@sections/Modals/UnavailableTimeModal'),
  'trial-confirmation-modal': () =>
    import('@sections/Modals/TrialConfirmation'),
  'upgrade-plan': () => import('@sections/Modals/UpgradePlan'),
  'apps-onboarding-modal': () => import('@sections/Modals/AppsOnboardingModal'),
  'save-filter-modal': () =>
    import('@/views/projects-list/sections/SaveFilterModal'),
  'custom-fields-filter-modal': () =>
    import('@/views/projects-list/sections/CustomFieldsFilterModal'),
  'allocation-confirm-modal': () =>
    import('@sections/Modals/AllocationConfirmModal'),
  'manage-users-modal': () => import('@sections/Modals/ManageUsersModal'),
  'downgrade-users-modal': () => import('@sections/Modals/DowngradeUsersModal'),
  'sample-projects-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/SampleProjectsModal'
    ),
  'personalized-experience-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/PersonalizedExperienceModal'
    ),
  'personalized-experience-accept-only-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/PersonalizedExperienceModal/PersonalizedExperienceAcceptOnlyModal'
    ),
  'project-template-preview-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/ProjectTemplatePreviewModal'
    ),
  'copy-project-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/CopyProjectModal'
    ),
  'add-edit-project-wizard-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/AddEditProjectWizardModal'
    ),
  'add-edit-custom-field': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/AddEditCustomField'
    ),
  'attach-task-lists-milestone-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/AttachTaskListsMilestoneModal'
    ),
  'report-builder': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@/views/reports/builder/sections/ReportBuilder'
    ),
  'upgrade-video-modal': () => import('@sections/Modals/UpgradeVideoModal'),
  'spaces-video-modal': () => import('@sections/Modals/SpacesVideoModal'),
  'switch-back-to-classic-modal': () =>
    import('@sections/Modals/SwitchBackToClassicModal'),
  'switch-everyone-to-new-teamwork-modal': () =>
    import('@sections/Modals/SwitchEveryoneToNewTeamworkModal'),
  'edit-recurring-task-modal': () =>
    import('@sections/Modals/EditRecurringTaskModal'),
  'user-group-picker-modal': () =>
    import(
      /* webpackChunkName: "frequentModals" */ '@sections/Modals/UserGroupPickerModal'
    ),
  'plan-trial-expired-modal': () =>
    import('@sections/Modals/PlanTrialExpiredModal'),
  'plan-trial-feedback-modal': () =>
    import('@sections/Modals/PlanTrialFeedbackModal'),
  'task-history-modal': () => import('@sections/Modals/TaskHistoryModal'),
  'update-time-log-modal': () => import('@sections/Modals/UpdateTimeLogModal'),
  'reports-export-google-auth-modal': () =>
    import('@sections/Modals/ReportsExportGoogleAuthModal'),
  'onboarding-checklist': () => import('@sections/Modals/OnboardingChecklist'),
  'scheduled-reporting-modal': () =>
    import('@sections/Modals/ScheduledReportingModal'),
  'repeating-interval-modal': () =>
    import('@sections/Modals/RepeatingIntervalModal'),
  'generic-action-confirm-modal': () =>
    import('@sections/Modals/GenericActionConfirmModal'),
  ...budgetModals,
  ...userRatesModals,
};
